import { apiFetch } from '@/lib/api';

export type CabinClass = 'economy' | 'premium_economy' | 'business' | 'first';

export interface SearchInput {
  origin: string;
  destination: string;
  departDate: string; // YYYY-MM-DD
  returnDate: string; // YYYY-MM-DD
  passengers?: number;
  cabinClass?: CabinClass;
  maxConnections?: 0 | 1 | 2;
  sort?: 'total_amount' | 'total_duration' | '-total_amount' | '-total_duration';
  limit?: number;
}

export interface OfferSliceLeg {
  origin?: string;
  destination?: string;
  departing_at?: string;
  arriving_at?: string;
  duration_min: number;
  stops: number;
  marketing: Array<{
    airline?: string;
    marketing_iata?: string;
    flight_number?: string;
  }>
}

export interface OfferSummary {
  offer_id: string;
  owner?: string;
  price: { amount: string; currency: string; expires_at?: string };
  total_duration_min: number;
  slices: OfferSliceLeg[];
}

export class FlightOffersService {
  async searchRoundTrip(input: SearchInput): Promise<{ offer_request_id: string; offers: OfferSummary[] }> {
    const res = await apiFetch('/api/flight/offers/search', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({ error: { message: 'Search failed' } }));
      throw new Error(err?.error?.message || 'Search failed');
    }
    const data = await res.json();
    return data.data;
  }
}



